import { useStoreActions } from '~/contexts';
import { useEventReporter } from '~/event-reporter';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { handleRequest } from '~/infra/utils';
export var LoginMethod = /*#__PURE__*/ function(LoginMethod) {
    LoginMethod["Password"] = "password";
    LoginMethod["OTP"] = "otp";
    LoginMethod["Google"] = "google";
    LoginMethod["Xero"] = "xero";
    LoginMethod["Intuit"] = "intuit";
    return LoginMethod;
}({});
export function useSendLoginGtmEvents() {
    const { sendEventToGtm } = useEventReporter();
    const { api } = useStoreActions();
    const { ME_V2_EXCLUDE_ACCOUNTANT_WORKSPACES } = useFeatureFlags();
    return {
        async sendGtmLoginSuccessEvent (method) {
            const getUserInfo = ME_V2_EXCLUDE_ACCOUNTANT_WORKSPACES ? api.auth.getUserInfoV2() : api.auth.getUserInfo();
            const userInfo = await handleRequest(getUserInfo);
            if (userInfo.data) {
                sendEventToGtm('login_success', {
                    user_id: userInfo.data.id(),
                    method
                });
            }
        },
        sendGtmLoginFailEvent (method, failReason) {
            sendEventToGtm('login_fail', {
                method,
                fail_reason: failReason || 'unknown'
            });
        }
    };
}
